import { render } from "./pdf-viewer.vue?vue&type=template&id=53650062"
import script from "./pdf-viewer.vue?vue&type=script&lang=js"
export * from "./pdf-viewer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Site résa/reservation.ogalo-saumurvaldeloire.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__